import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DragHandle from '@components/common/DnD/DragHandle';
import { BreakdownChartCard } from './ApiUsageBreakdownChart';

interface SortableChartItemProps {
  metric: string;
  seriesData: any;
  isFetching: boolean;
  isError: boolean;
}

const SortableChartItem = ({ metric, seriesData, isFetching, isError }: SortableChartItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: metric,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    position: 'relative' as const,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <DragHandle {...attributes} {...listeners} />
      <BreakdownChartCard
        metric={metric}
        seriesData={seriesData}
        isFetching={isFetching}
        isError={isError}
      />
    </div>
  );
};

export default SortableChartItem;
